import * as React from "react"
import { Route, BrowserRouter } from "react-router-dom"
import { connect } from "react-redux"
import router from "@/router/index"

const route = ((router) => {
  return router.map(function (item: any, index: number) {
    return (
      <Route
        path={item.path}
        key={index}
        exact={true}
        render={(props: any) => {
          window.scroll(0, 0)
          document.title = item.title || "我的"
          if (item.backgroundColor) {
            document.body.style.backgroundColor = item.backgroundColor
          } else {
            document.body.style.backgroundColor = ""
          }
          return <item.component.default {...props} />
        }}
      ></Route>
    )
  })
})(router)

class App extends React.Component<any, any> {
  constructor(props: any) {
    super(props)
    this.state = {
      addressInfo: {},
    }
  }

  componentDidMount() {}

  public render() {
    return (
      <div className="App">
        <BrowserRouter basename="/mobile/uc/build">{route}</BrowserRouter>
      </div>
    )
  }
}

export default connect((state) => state)(App)
